<template>
    <div>
        <div id="container">
			<div id="content">
				<span>
					<div id="message"></div>
				</span>
			</div>
			
		</div>
    </div>
</template>
<script>
export default {
    name:'Contnews',
    methods:{
        checkload:function (){
            var insertPoint = document.getElementById('container');
			var iframe = document.createElement('iframe');
			iframe.allowTransparency = "true";
            iframe.setAttribute('src', 'http://web.qvwen.cn/qvwcn/Contdetailpage');
			// iframe.setAttribute('src', 'http://localhost:8080/Contdetailpage');
			iframe.width = '100%';
			iframe.height = '250px';
			iframe.setAttribute('frameborder', 0);
			iframe.id = "zl-cprzy312";
			iframe.scrolling = "no";
			iframe.style.display = 'block';
			iframe.referrerpolicy = 'no-referrer';
			insertPoint.parentNode.insertBefore(iframe, insertPoint);
        }
    },
    mounted:function(){
        this.checkload();
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/viewsource/Contnews.vue